import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { Container } from 'Components/core';
import { layout, colors } from 'Constants';

const NavItem = styled.span`
  position: relative;
  color: ${colors.text};
  transition: 0.2s color;
  cursor: pointer;

  :hover {
    color: ${colors.accent};
  }

  > .dropdown {
    display: none;
  }

  :hover > .dropdown {
    display: flex;
  }
`;

const LinkCustom = styled(Link)`
  text-decoration: none;
`;

const NavDropdown = styled.div`
  position: absolute;
  top: 100%;
  z-index: 10;
  display: flex;
  flex-direction: column;
  width: 350px;
  padding: 16px;
  background: ${colors.background};
  box-shadow: 0 0 10px 0px #aaa;

  > * {
    padding: 8px 4px;
  }
`;

const HamburgerDropdown = styled(NavDropdown)`
  top: calc(100% + 5px);
  width: 100vw;
  left: -16px;
  right: 16px;
  margin-left: 0 !important;
  display: none;

  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    display: flex;
  }
`;

const SubCard = styled(Container)`
  padding: 8px;
  background: ${colors.backgroundAlt};
  > * {
    padding: 8px 4px;
    margin-left: 16px;
  }
`;

// TODO: URL for Logo?
// FIXME: coBrandUrl
export default props => {
  const state = props.state;

  const NavLink = innerProps => (
    <LinkCustom to={`${innerProps.to}${location.search}`}  onClick={() => props.closeHamburger()}>
      <NavItem>{innerProps.children}</NavItem>
    </LinkCustom>
  );

  return (
    <HamburgerDropdown style={props.style}>
      <NavLink to="/">Home</NavLink>
      {state?.asaCoverage?.eligible && <NavLink className="desktop" to="/eligibility">
                Eligibility
      </NavLink>}
      {state.includeAsaCoverage && <NavLink  className="desktop" to="/coverage-periods-rates">
              Coverage
      </NavLink>
      }

   
              
      {state.includeAsaPlan && <NavLink className="desktop" to="/plan-details">
              Plan details
      </NavLink>}

      
      {state.includeAsaWhereForCare && <NavLink className="desktop" to="/care">
      Access Care
      </NavLink>}



      {<NavLink className="desktop" to="https://players.brightcove.net/3707693280001/default_default/index.html?videoId=6309466729112" target='_blank'>
                Healthcare 101
                </NavLink>}

      {state.includeAsaImportantContacts&&
                 <NavLink className="desktop" to="/Contacts">
              Contacts
                 </NavLink>}
    </HamburgerDropdown>
  );
};
